<template>
  <v-btn :block="block" :small="small" elevation="0" v-bind="filteredAttrs" v-on="$listeners" :class="computedClass"
    :disabled="disabled">
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    intent: String,
    small: Boolean,
    block: Boolean,
    disabled: Boolean
  },
  default: {
    small: false,
    block: false,
    disabled: false
  },
  computed: {
    filteredAttrs() {
      // eslint-disable-next-line
      const { class: _class, ...rest } = this.$attrs;
      return rest;
    },
    computedClass() {
      switch (this.intent) {
        case "link":
          return ["plusBlueDarken1--text plusGreyLighten3"];
        case "primary":
          return ["plusIndigoDarken2", "white--text"];
        case "error":
          return ["plusError", "white--text"];
      }
      return ["buttonDefault"];
    }
  }
}
</script>

<style scoped>
.buttonDefault {
  border: 1px solid rgba(0, 0, 0, 0.87);

}
</style>
